import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { countries } from "countries-list";
import { forgotPassword, resetPinCall } from "actions/Auth";
import { submitNotificationPerformance } from "actions/App";
import moment from "moment"
import ButtonContained from "components/ButtonContained";
import TextInput from "components/TextInput";
import CountryCodeSelector from "components/CountryCodeSelector";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const intl = useIntl();
  const loginConfirm = useSelector((state) => state.auth.loginConfirm);
  useEffect(() => {
    document.title = "Forgot Password | Smart Entry";
  }, []);

  const [requestPin, setRequestPin] = useState(false);
  const sessionConfirm = JSON.parse(sessionStorage.getItem("login_confirm"));
  const localConfirm = JSON.parse(localStorage.getItem("login_confirm"));
  const confirm = sessionConfirm || loginConfirm || localConfirm;
  const country = Object.values(countries).filter(c => c.phone[0] == (confirm.countryCode) && c.name == confirm.countryName)[0] || countries["US"];
  const phoneLogin = confirm ? (confirm.phone ? true : false) : true;
  const phone = confirm ? confirm.phone : "";
  const email = confirm ? confirm.email : "";
  const password = "";

  const submit = (e) => {
    e.preventDefault();
    dispatch(submitNotificationPerformance({
      notification_id: phoneLogin ? phone : email,
      notification_type: "password_reset",
      notification_name: "password_reset",
      start_time: moment().utc()
    }));
    requestPin
    ?
    dispatch(resetPinCall({ countryCode: country.phone[0].toString(), phone, email, companyUUID: "-1",message: intl.formatMessage({ id: "notifications.success.sent" }) }))
    :
    dispatch(forgotPassword({ country, phone, email, password, phoneLogin, countryCode: country.phone[0].toString(),message: intl.formatMessage({ id: "notifications.success.sent" }) }));
  };

  return (
    <div className="h-full flex flex-col">
      <label className="flex flex-col">
        <h5 className="tw-heading-5 font-bold text-black">
          {intl.formatMessage({ id: "auth.forgot.header" })}
        </h5>
        <p className="tw-paragraph-reg flex items-center">
          {intl.formatMessage({
              id: requestPin
                  ? "auth.forgot.paragraphPin"
                  : phoneLogin
                  ? "auth.forgot.paragraphPhone"
                  : "auth.forgot.paragraphEmail"
          })}
        </p>
      </label>

      <div className="flex flex-col justify-between">
        <form>
          {phoneLogin ? (
            <div className="mt-6 mb-16 flex items-center gap-2 h-[53px]">
              <CountryCodeSelector
                id="Forgot-Password-Country-Code-Selector"
                dataCy="Forgot-Password-Country-Code-Selector"
                disabled={true}
                selectedCountry={country}
                onSelect={(country) => setCountry(country)}
              />
              <TextInput
                id="Forgot-Password-Phone-Text-Input"
                dataCy="Forgot-Password-Phone-Text-Input"
                type="tel"
                name="tel"
                placeholder={`${intl.formatMessage({id: "form.phone"})}`}
                onChange={(e) => setPhone(e.target.value)}
                isDisabled={true}
                value={phone}
                validateInput={(val) => /^\d*$/.test(val)} // only digits
                buttonOneIcon="arrowRight"
                buttonOneAction={(e) => submit(e)}
              />
            </div>
          ) : (
            <div className="mt-6 mb-16 w-full">
              <TextInput
                id="Forgot-Password-Email-Text-Input"
                dataCy="Forgot-Password-Email-Text-Input"
                type="email"
                name="email"
                isDisabled={true}
                placeholder={intl.formatMessage({ id: `form.email` })}
                value={email}
                buttonOneIcon="arrowRight"
                buttonOneAction={(e) => submit(e)}
              />
            </div>
          )}
          <div className="flex flex-col gap-4 items-start">
            {phoneLogin && <ButtonContained
              id="Forgot-Password-Continue-Button"
              dataCy="Forgot-Password-Continue-Button"
              text={intl.formatMessage({ id: !requestPin ? "auth.reset.requestPin" : "auth.reset.phone" })}
              type="default"
              buttonType="submit"
              onClick={(e) => {
                e.preventDefault();
                setRequestPin(!requestPin)
              }}
            />}
            <ButtonContained
              id="Forgot-Password-Cancel-Button"
              dataCy="Forgot-Password-Cancel-Button"
              text={intl.formatMessage({id: "comp.button.cancel"})}
              type="default"
              onClick={(e) => {
                e.preventDefault();
                history.push("/signin")
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;